import { jsx as _jsx } from "react/jsx-runtime";
import { CAPTURE_HEADING_CLASS } from './captureHeadingDom';
/** A captured element or authored issue name; the host retains its controls. */
export function CaptureHeading({ title, as: Tag = 'span', className = '' }) {
    return _jsx(Tag, { className: `${CAPTURE_HEADING_CLASS} ${className}`.trim(), "data-capture-heading": "", role: Tag === 'span' ? 'heading' : undefined, "aria-level": Tag === 'span' ? 3 : undefined, children: title });
}
//# sourceMappingURL=CaptureHeading.js.map